var map = {
	"./Foto 1.jpg": 8461,
	"./Foto 10.jpg": 9473,
	"./Foto 11.jpg": 5076,
	"./Foto 12.jpg": 9235,
	"./Foto 13.jpg": 2774,
	"./Foto 14.jpg": 7533,
	"./Foto 15.jpg": 6400,
	"./Foto 16.jpg": 15,
	"./Foto 2.jpg": 9234,
	"./Foto 3.jpg": 943,
	"./Foto 4.jpg": 6308,
	"./Foto 5.jpg": 4465,
	"./Foto 6.jpg": 2262,
	"./Foto 7.jpg": 2371,
	"./Foto 8.jpg": 4760,
	"./Foto 9.jpg": 9077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8135;